import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/choice',
    name: 'Choice',
    component: () => import(/* webpackChunkName: "choice" */ '../views/Choice.vue')
  },
  {
    path: '/debt',
    name: 'Debt',
    component: () => import(/* webpackChunkName: "debt" */ '../views/Debt.vue')
  },
  {
    path: '/income',
    name: 'Income',
    component: () => import(/* webpackChunkName: "income" */ '../views/Income.vue')
  },
  {
    path: '/expenses',
    name: 'Expenses',
    component: () => import(/* webpackChunkName: "expenses" */ '../views/Expenses.vue')
  },
  {
    path: '/results',
    name: 'Results',
    component: () => import(/* webpackChunkName: "results" */ '../views/Results.vue')
  },
  {
    path: '/next-options',
    name: 'NextOptions',
    props: true,
    component: () => import(/* webpackChunkName: "next-options" */ '../views/NextOptions.vue')
  },
  {
    path: '/occupation',
    name: 'Occupation',
    component: () => import(/* webpackChunkName: "occupation" */ '../views/Occupation.vue')
  },
  {
    path: '/cover-cost',
    name: 'CoverCost',
    component: () => import(/* webpackChunkName: "cover-cost" */ '../views/CoverCost.vue')
  },
  {
    path: '/next',
    name: 'Next',
    component: () => import(/* webpackChunkName: "results" */ '../views/Next.vue')
  },
  {
    path: '/assumptions/:activeTab',
    name: 'Assumptions',
    props: true,
    component: () => import(/* webpackChunkName: "assumptions" */ '../views/Assumptions.vue')
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: () => import(/* webpackChunkName: "disclaimer" */ '../views/Disclaimer.vue')
  },
  {
    path: '/intro/:choice',
    name: 'Intro',
    props: true,
    component: () => import(/* webpackChunkName: "intro" */ '../views/Intro.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
})

export default router
